// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map {
  --vis-map-cluster-inner-label-text-color-dark: orange;
  --vis-map-cluster-inner-label-text-color-light: yellow;
  --vis-dark-map-cluster-inner-label-text-color-dark: yellow;
  --vis-dark-map-cluster-inner-label-text-color-light: orange;


  --vis-map-point-inner-label-text-color-dark: yellow;
  --vis-map-point-inner-label-text-color-light: orange;
  --vis-dark-map-point-inner-label-text-color-dark: green;
  --vis-dark-map-point-inner-label-text-color-light: white;
}

.toggle-button {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1000;
}
`, "",{"version":3,"sources":["webpack://./src/examples/maps/leaflet/leaflet-map-css-vars/style.module.css"],"names":[],"mappings":"AAAA;EACE,qDAAqD;EACrD,sDAAsD;EACtD,0DAA0D;EAC1D,2DAA2D;;;EAG3D,mDAAmD;EACnD,oDAAoD;EACpD,uDAAuD;EACvD,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;AACf","sourcesContent":[".map {\n  --vis-map-cluster-inner-label-text-color-dark: orange;\n  --vis-map-cluster-inner-label-text-color-light: yellow;\n  --vis-dark-map-cluster-inner-label-text-color-dark: yellow;\n  --vis-dark-map-cluster-inner-label-text-color-light: orange;\n\n\n  --vis-map-point-inner-label-text-color-dark: yellow;\n  --vis-map-point-inner-label-text-color-light: orange;\n  --vis-dark-map-point-inner-label-text-color-dark: green;\n  --vis-dark-map-point-inner-label-text-color-light: white;\n}\n\n.toggle-button {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  z-index: 1000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"map": `map`,
	"toggleButton": `toggle-button`
};
export default ___CSS_LOADER_EXPORT___;
